import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-[var(--bg-secondary)]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
        <div>
          <p className="font-display text-lg text-[var(--ink-heading)] mb-2">
            GovDataCierge
          </p>
          <p className="text-[var(--ink-secondary)] leading-relaxed max-w-xs">
            A KATLAS Cierge demo. Synthetic public-sector sandbox. No real
            citizen, taxpayer or operational data is used.
          </p>
        </div>
        <div>
          <p className="eyebrow mb-3">Walkthrough</p>
          <ul className="space-y-1.5 text-[var(--ink-secondary)]">
            <li><Link to="/walkthrough" className="hover:text-[var(--ink-heading)]" data-testid="footer-walkthrough">Design walkthrough</Link></li>
            <li><Link to="/sponsor" className="hover:text-[var(--ink-heading)]" data-testid="footer-sponsor">Sponsor view</Link></li>
            <li><Link to="/requests" className="hover:text-[var(--ink-heading)]" data-testid="footer-requests">Reuse requests</Link></li>
            <li><Link to="/portfolio" className="hover:text-[var(--ink-heading)]" data-testid="footer-portfolio">Portfolio</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-3">Operational</p>
          <ul className="space-y-1.5 text-[var(--ink-secondary)]">
            <li>
              <Link to="/diagnostics" className="hover:text-[var(--ink-heading)]" data-testid="footer-diagnostics">
                KATLAS diagnostics
              </Link>
            </li>
          </ul>
          <p className="text-xs text-[var(--ink-muted)] mt-6 max-w-xs leading-relaxed">
            AI may suggest. Authorised reviewers decide. KATLAS signs the receipt.
          </p>
        </div>
      </div>
    </footer>
  );
}
